import { render, staticRenderFns } from "./ModalConsistencyDetails.vue?vue&type=template&id=5c5f4456"
import script from "./ModalConsistencyDetails.vue?vue&type=script&lang=js"
export * from "./ModalConsistencyDetails.vue?vue&type=script&lang=js"
import style0 from "./ModalConsistencyDetails.vue?vue&type=style&index=0&id=5c5f4456&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports